module.exports = __webpack_public_path__ + "img/Dark-Mode.c4a25477.svg";